import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './Context/AuthContext';
import RequireAuth from './Components/RequireAuth';
import AdminLayout from './Layouts/AdminLayout';
import Dashboard from './Pages/Dashboard';
import QuestionList from './Pages/QuestionManager/QuestionList';
import CreateQuestion from './Pages/QuestionManager/CreateQuestion';
import GameList from './Pages/GameManager/GameList';
import CreateGame from './Pages/GameManager/CreateGame';
import GameDetail from './Pages/GameManager/GameDetail';
import QuestionPool from './Pages/QuestionManager/QuestionPool';
import Lobby from './Pages/Contest/Lobby';
import ModeratorPanel from './Pages/Contest/ModeratorPanel';  
import Login from './Pages/Login';
import { QuestionProvider } from './Context/QuestionContext';
import { ContestProvider } from './Context/ContestContext';
import { GameProvider } from './Context/GameContext';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <GameProvider>
          <QuestionProvider>
            <ContestProvider>
              <Routes>
                <Route path="/login" element={<Login />} />
                
                <Route path="/" element={
                    <RequireAuth>
                      <AdminLayout />
                    </RequireAuth>
                }>
                  <Route index element={<Dashboard />} />
                  <Route path="games" element={<GameList />} />
                  <Route path="games/new" element={<CreateGame />} />
                  <Route path="games/:id" element={<GameDetail />} />
                  
                  {/* Global Question Pool */}
                  <Route path="questions" element={<QuestionPool />} />
                  <Route path="questions/new" element={<CreateQuestion />} />
                  
                  <Route path="lobby" element={<Lobby />} />
                  <Route path="contest" element={<ModeratorPanel />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </ContestProvider>
          </QuestionProvider>
        </GameProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
